'use strict';

var window = require('window'),
    globalVars = window.globalVars || {},
    gtxLoggedUser = window.gtxLoggedUser || {};

module.exports = function (path) {
    var splittedPath,
        constant;

    if (globalVars.APP_DEBUG && !path) {
        throw new Error('Percorso della risorsa mancante');
    }

    splittedPath = path.split('.');

    constant = splittedPath.reduce(function (gtxLoggedUser, i) {
        return gtxLoggedUser[i];
    }, gtxLoggedUser);

    if (globalVars.APP_DEBUG && typeof constant === 'undefined') {
        throw new Error('La proprietà ' + name + ' non è definita');
    }

    return constant;
};
